






























































































  import { Component, Vue } from 'vue-property-decorator';
  import XLSX from 'xlsx'; 
  import { IUser, EUserStatus, EUserGroup } from "@/components/shared/types";
  import { User } from "@/components/User";
  import { L } from "@/common/filters";
  import { isString, isObject, isEmptyObject, sortObjectArray } from "@/common/utils";
  import { ICodeList } from "@/components/map/types";

  @Component({
    watch: {
      pagination: {
        deep: true,
        handler() {
          this.fetchUsers();
        }
      }
    }
  })
  export default class UserLists extends Vue {
    RowsPerPage = [15];
    showMini:boolean = true;
    loading:boolean = false;
    totalUsers:number = 0;
    users:User[] = [];
    srhKwd:string = null;

    pagination:any = {};

    get headers() {
      return [{
            text: L('group'),
            align: 'left',
            //sortable: false,
            value: 'GroupName'
          },{
            text: L(['name',' - ', '^surname$']),
            align: 'left',
            //sortable: false,
            value: 'FullName'
          },/*{
            text: L('mobileNo'),
            align: 'left',
            //sortable: false,
            value: 'Mobile'
          },*/{
            text: L('organization'),
            align: 'left',
            //sortable: false,
            value: 'OrgAbbr'
          },{
            text: L('adminUser'),
            align: 'center',
            sortable: false,
            value: 'Code'
          }
        ];
    }

    created() {
      //this.fetchUsers();
    }

    mounted() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    get User() : User {
      return this.$store.getters.User;
    }

    set User(user:User) {
      this.$store.commit('notifyChange', {
        User: user
      });
    }

    get language() : string {
      return this.$store.getters.Language;
    };

    async fetchUsers() {
      if (this.loading) {
        return;
      }
      try {
        let data: any = {
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage
        };
        if (this.User.isAdmins) {
          data.o = this.User.OrgCode;
        }
        if (!!this.srhKwd) {
          data.q = this.srhKwd;
        }
        this.loading = true;
        data = await this.User.requestResource('user/search', 'GET', data);
        this.totalUsers = data.total;
        this.users = data.lists.map((u) => {
          let user = new User();
          user.PropertiesFromStorage = u;
          return user;
        });
        let sortBy = this.pagination.sortBy + (this.pagination.descending ? ' desc' : '');
        sortObjectArray(this.users, sortBy);
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    };

    searchUsers() {
      this.srhKwd = this.srhKwd ? this.srhKwd.trim() : null;
      this.users = [];
      this.totalUsers = 0;
      this.pagination.page = 1;
      this.fetchUsers();
    }

    async exportToExcel() {
      try {
        let data:any; //limited as defined in database
        if (!!this.srhKwd) {
          data = {
            q: this.srhKwd,
            limit: 0 //not limited
          }
        }
        this.loading = true;
        data = await this.User.requestResource('user/search', 'GET', data);
        let lists = data.lists.map((list) => {
          let gn = EUserGroup[list.group];
          gn = gn.charAt(0).toLowerCase() + gn.slice(1);
          let orgAbbr = list['org_abbr_' + this.User.Language] || null;
          let orgName = list['org_name_' + this.User.Language] || null;
          if (orgName && orgAbbr) {
            orgName += ' (' + orgAbbr + ')';
          } else if (!orgName && orgAbbr) {
            orgName = orgAbbr;
          }
          let on = list.org_name && list.org_
          return {
            "ชื่อ" : list.given_name,
            "นามสกุล": list.surname,
            "อีเมล์": list.email,
            "เบอร์มือถือ": list.mobile,
            "เลขประจำตัวฯ" : list.ssn,
            "กลุ่มผู้ใช้": L(gn),
            "หน่วยงาน": orgName
          };
        });
        let ws = XLSX.utils.json_to_sheet(lists);
        let wb = XLSX.utils.book_new(); // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, ws, 'รายชื่อผู้ใช้') ;
        XLSX.writeFile(wb, 'gisagro-users.xlsx') ;
        this.loading = false;
      } catch (error) {
        this.loading = false;
console.log(error);
      }
    }
    
    addUser() {
      this.$emit('changeMenu',{
        name: 'adminadduser'
      });
    }

    showUserProfile(user:User) {
      this.$emit('changeMenu',{
        name: 'userprofile',
        data: user
      });
    }

    showUserLogs(user:User) {
      this.$emit('changeMenu', {
        name: 'adminuserlogs',
        data: user
      });
    }

    revokeGrant(user:User) {
      let $this = this;
      if (user.Status==EUserStatus.Active) {
        this.$store.commit('notifyChange', {
          Dialog: {
            Type: 'info',
            Title: 'attention',
            Message: L('sAreYouGoingToRevokeUserAccount',[user.FullName]),
            OkText: 'yes',
            CancelText: 'no',
            show: true,
            OnClose: (answer) => {
              if (answer=='ok') {
                $this.doChangeUserStatus(user, EUserStatus.Revoked);
              }
            }
          }
        });
      } else {
        this.$store.commit('notifyChange', {
          Dialog: {
            Type: 'info',
            Title: 'attention',
            Message: L('sAreYouGoingToGrantUserAccount',[user.FullName]),
            OkText: 'yes',
            CancelText: 'no',
            show: true,
            OnClose: (answer) => {
              if (answer=='ok') {
                $this.doChangeUserStatus(user, EUserStatus.Active);
              }
            }
          }
        });
      }
    }

    async doChangeUserStatus(user:User, status:EUserStatus) {
      try {
        this.User.requestResource('user', 'PUT', {
          uid: user.HalloId,
          ustatus: status
        });
        user.Status = status;
      } catch (error) {
        let e = error;
        console.log(error);
      }
    }

    async logout() {
      try {
        await this.User.logout();
        this.$store.commit('notifyChange', {
          User: new User(),
          SelectedApp: 'login'
        });
      } catch (error) {
      }
    }
  }
